import { render, staticRenderFns } from "./FiltrosArmazem.vue?vue&type=template&id=50872427&scoped=true&"
import script from "./FiltrosArmazem.vue?vue&type=script&lang=js&"
export * from "./FiltrosArmazem.vue?vue&type=script&lang=js&"
import style0 from "./NavBar/style.css?vue&type=style&index=0&id=50872427&scoped=true&lang=css&"
import style1 from "./FiltrosArmazem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50872427",
  null
  
)

export default component.exports